module.exports = __webpack_public_path__ + "img/uruguay-logo-icon.22536272.png";